import { useQuery } from '@tanstack/react-query';

import type { Company, MeMenuCategory } from './types';

import { useApiClient } from '@/shared/api';

/**
 * 일반 사용자용(/me) 훅. 로그인만으로 호출 가능.
 * GNB 와 조회 화면의 법인 드롭다운을 이걸로 채운다.
 */

/** GET /api/v1/me/menus — 내가 접근 가능한 메뉴 트리(그대로 GNB 로 그린다). */
export const useMyMenusQuery = () => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['me-menus'],
    queryFn: () => apiClient.get<MeMenuCategory[]>('api/v1/me/menus'),
  });
};

/**
 * GET /api/v1/me/companies?menuId= — 이 메뉴에서 조회 가능한 법인.
 * 메뉴마다 결과가 다르므로 화면을 열 때마다 그 화면 menuId 로 호출한다(전역 캐시 금지).
 * 빈 배열 = 그 메뉴로 아무 법인도 조회 불가 → 드롭다운 비활성 + 안내.
 */
export const useMyCompaniesQuery = (menuId: number | null) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['me-companies', menuId],
    queryFn: () =>
      apiClient.get<Company[]>('api/v1/me/companies', { menuId: menuId! }),
    enabled: menuId != null,
  });
};
